import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDI } from "@infra/di/useDI";
import { useRegistrationSuccessViewModel } from "./SuccessViewModel";
import { AuthCard, AuthContent, AuthPage } from "../layout";

export default function RegistrationSuccessPage() {
  const { registrationId } = useParams<{ registrationId: string }>();
  const navigate = useNavigate();
  const { completeRegistrationAuthentication, registrationService } = useDI();

  const { state, intents } = useRegistrationSuccessViewModel({
    registrationId,
    registrationService,
    completeRegistrationAuthentication,
    onAuthenticated: () => navigate("/dashboard", { replace: true }),
  });

  return (
    <AuthPage>
      <AuthCard>
        <AuthContent>
          <Stack spacing={3} alignItems="center">
            {(state.uiState.status === "loading" ||
              state.uiState.status === "waiting" ||
              state.uiState.status === "success") && <CircularProgress />}

            <Stack spacing={1} alignItems="center">
              <Typography variant="h5" fontWeight={700} textAlign="center">
                {state.uiState.title}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                textAlign="center"
              >
                {state.uiState.message}
              </Typography>
            </Stack>

            {state.uiState.status === "error" ? (
              <>
                <Alert severity="error" sx={{ width: "100%" }}>
                  {state.uiState.message}
                </Alert>

                <Stack direction="row" spacing={2}>
                  <Button variant="outlined" onClick={intents.retryNow}>
                    Erneut prüfen
                  </Button>

                  {state.uiState.canRetry ? (
                    <Button
                      variant="contained"
                      onClick={intents.goToRegistration}
                    >
                      Neu starten
                    </Button>
                  ) : null}
                </Stack>
              </>
            ) : null}
          </Stack>
        </AuthContent>
      </AuthCard>
    </AuthPage>
  );
}
